import nudgeAngelDispatcher from '../action';

const initialState = {
  list: [],
  paging: {
    pageIndex: 0,
    pageSize: 10,
    totalItem: 0,
    totalPage: 0,
  },
};

const nudgeAngelReducer = nudgeAngelDispatcher(initialState, {
  [nudgeAngelDispatcher.getDataSuccess]: (state, payload) => ({
    list: payload.data.list,
    paging: {
      ...payload.data,
      list: undefined,
    },
  }),
  [nudgeAngelDispatcher.setState]: (state, payload) => ({
    [payload.state]: payload.value,
  }),
  [nudgeAngelDispatcher.resetData]: (state, _) => ({
    ...initialState,
  }),
});

export default nudgeAngelReducer;
